<ui-label class="sp-mr-0" *ngFor="let label of visibleLabels" [uiColor]="label.color" [attr.data-test-id]="'check-in-label'">
  {{ (label.type === "notPublished" ? "check_ins_no_check_in" : "reflections_overview_" + label.type) | localize }}
</ui-label>
<ui-avatar class="hidden-labels-number" *ngIf="hiddenLabels?.length > 0" [uiText]="'+' + hiddenLabels?.length" uiSize="xs" ui-tooltip uiTooltipPlacement="bottom"> </ui-avatar>
